module.exports = __webpack_public_path__ + "img/marketing_fr@2x.011f0225.png";